export enum VesselMigrationDataType {
    TANKS = 'TANKS',
    STOCKS = 'STOCKS',
    CONSUMPTION_PRESETS = 'CONSUMPTION_PRESETS',
}

export interface VesselMigrationRequestMessage {
    targetVesselId: string;
    dataTypes: VesselMigrationDataType[];
}

export interface VesselMigrationResultMessage {
    targetVesselId: string;
    copiedTanks: number;
    copiedStocks: number;
    copiedConsumptionPresets: number;
}
